<template>
  <div class="home">
    <img
      alt="ss logo"
      src="https://cdn.samsung.com/etc/designs/smg/global/imgs/svg-logo.svg">
    <h1>Samsung Mobile Welcome Page Editor</h1>
    <p>SMWPE is de 'achterkant' van de Mobile Welcome Page</p>
  </div>
</template>

<script>
import { firebase } from "../firebase";

export default {
  name: "Home",
  components: {},
  data() {
    return {};
  },
  beforeCreate() {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        this.$router.push("/login");
      }
    });
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 2rem;
  margin: 1rem 0;
}
</style>




